<template>
  <div>
    <v-container v-if="!anyInProgress">
      <v-row>
        <v-col cols="3">
          <v-select v-model="selectedMarketplaceID" :items="marketplaces" item-text="name" item-value="id"
            label="Marketplace to Scan" style="height: 30px;" outlined dense></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-btn color="primary" v-on:click="startScan" block :disabled="!selectedMarketplaceID">
            <v-icon>search</v-icon>
            Get new Snapshot
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row>
        <v-col cols="3">
          <v-select v-model="selectedMarketplaceID" :items="marketplaces" item-text="name" item-value="id"
            label="Marketplace to Scan" style="height: 30px;" outlined dense disabled></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-btn color="primary" block disabled>
            <v-icon>search</v-icon>
            Scan in progress...
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-subheader>
      Scan status: {{ this.scanStatus }}
      <span v-if="anyInProgress">
        <v-progress-circular :value="progressPercent" color="primary" class="ml-2" />
        Progress %: {{ this.progressPercent }}
      </span>
    </v-subheader>
  </div>

</template>

<script>
import { SnapshotsService } from '../../services/api/snapshots';
import { MarketplacesService } from '../../services/api/marketplaces';
const apiSnapshots = new SnapshotsService();
const apiMarketplaces = new MarketplacesService();

export default {
  props: {
    catCodeString: String,
  },

  data() {
    return {
      anyInProgress: false,
      progressPercent: 0,
      scanStatus: "[status]",
      marketplaces: [],
      selectedMarketplaceID: null,
    }
  },

  created() {
    // Listen to status changes coming from SignalR events
    this.$scannerHub.$on('status-changed', this.onStatusChanged)
  },

  mounted() {
    this.getAnyInProgress();
    this.getMarketplaces();
  },

  methods: {

    getMarketplaces() {
      apiMarketplaces.getMarketplaces().then((data) => {
        this.marketplaces = data
        if (this.marketplaces.length > 0)
          this.selectedMarketplaceID = this.marketplaces[0].id;
      });
    },

    startScan() {
      this.anyInProgress = true;
      if (!this.selectedMarketplaceID)
        return;
      
      apiSnapshots.startScanForMarketplace(this.selectedMarketplaceID, this.catCodeString);
    },

    // This is called from the server through SignalR
    onStatusChanged({ scanProgress }) {
      console.log("onStatusChanged scanProgress: ");
      console.log(scanProgress);
      this.scanStatus = scanProgress.newStatus;
      this.progressPercent = scanProgress.progressPercent;
      this.anyInProgress = scanProgress.scanInProgress;
    },

    getAnyInProgress() {
      apiSnapshots.anyScansInProgress(this.catCodeString).then((data) => {
        this.anyInProgress = data.anyScansInProgress
        if (!this.anyInProgress)
          this.scanStatus = "Idle";
      });
    },

  }
}
</script>
